import Vue from 'vue';

Vue.filter('filterCountry', value => {
	switch (value) {
		case 'DE':
			value = 'Deutschland';
			break;
		case 'LU':
			value = 'Luxemburg';
			break;
		default:
			value = 'Deutschland';
	}

	return value;
});

Vue.filter('filterSalutation', value => {
	switch (value) {
		case 'MR':
			value = 'Junge';
			break;
		case 'MRS':
			value = 'Mädchen';
			break;
		default:
			value = 'Junge';
	}

	return value;
});

Vue.filter('filterMonth', value => {

    switch (value){
        case '01':
            value = 'Januar';
            break;
        case '02':
            value = 'Februar';
            break;
        case '03':
            value = 'März';
            break;
        case '04':
            value = 'April';
            break;
        case '05':
            value = 'Mai';
            break;
        case '06':
            value = 'Juni';
            break;
        case '07':
            value = 'Juli';
            break;
        case '08':
            value = 'August';
            break;
        case '09':
            value = 'September';
            break;
        case '10':
            value = 'Oktober';
            break;
        case '11':
            value = 'November';
            break;
        case '12':
            value = 'Dezember';
    }

    return value;
});